import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=2a441f9a"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"
import style0 from "./switch.vue?vue&type=style&index=0&id=2a441f9a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a441f9a')) {
      api.createRecord('2a441f9a', component.options)
    } else {
      api.reload('2a441f9a', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=2a441f9a", function () {
      api.rerender('2a441f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Configuraciones/Discord/switch.vue"
export default component.exports